import React, {Component} from 'react'

class Cabecalho extends Component {

    constructor(props) {
        super(props);
        this.state = {
            servidor: props.servidor,
        }
    }
    
    render() {
        const teste = 1;
        return(
            <div className="header header-bg"></div>
        )
    }
}
export default Cabecalho